import "./DeleteModal.styles.scss";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const DeleteModal = ({
  open,
  item_name,
  handleClose,
  handleSubmit,
}: {
  open: boolean;
  item_name: string | null;
  handleClose: () => void;
  handleSubmit: () => void;
}) => {
  return (
    item_name && (
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="delete-modal-dialog-title"
        aria-describedby="delete-modal-dialog-description"
        className="delete-modal"
      >
        <DialogTitle id="delete-modal-dialog-title">Delete</DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-modal-dialog-description">
            {`Are you sure you want to delete ${item_name}? This action is permanent and cannot be undone.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} className="delete-modal-cancel-button">
            Cancel
          </Button>
          <Button onClick={handleSubmit} className="delete-modal-delete-button">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    )
  );
};

export default DeleteModal;
